import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    categoryList: null,
    newCategoryList: null,
    allConfigFile: [],
    configFileData: [],
    previousSelectedPartialConfigId: null,
  },
  getters: {
    categoryList: (state) => state.categoryList,
    newCategoryList: (state) => state.newCategoryList,
    allConfigFile: (state) => state.allConfigFile,
    configFileData: (state) => state.configFileData,
    listOfRule: (state) => state.listOfTest,
    previousSelectedPartialConfigId: (state) => state.previousSelectedPartialConfigId,
  },
  actions: {
    loadModelCategory(context, modelID) {
      return new Promise((resolve, reject) => {
        alice
          .loadModelCategory(modelID)
          .then((response) => {
            context.commit('setModelCategoryData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getModelCategory(context, modelID) {
      return new Promise((resolve, reject) => {
        alice
          .loadModelCategory(modelID)
          .then((response) => {
            context.commit('setNewModelCategoryData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllConfigFile(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllConfigFile()
          .then((response) => {
            context.commit('setAllConfigFileData', response.data.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getConfigFile(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .getConfigFile(configId)
          .then((response) => {
            context.commit('setConfigFileData', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPartialConfigWithChild(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .getPartialConfigWithChild(configId)
          .then((response) => {
            context.commit('setConfigFileData', response.data.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPartialConfigByPartialConfigParentId(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .getPartialConfigByPartialConfigParentId(configId)
          .then((response) => {
            context.commit('setConfigFileData', response.data.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createConfigFile(context, params) {
      const configData = params;
      return new Promise((resolve, reject) => {
        alice
          .createConfigFile(configData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createPartialConfig(context, params) {
      const
        configData = params;
      return new Promise((resolve, reject) => {
        alice
          .createPartialConfig(configData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateConfigFile(context, params) {
      const { configId, configData } = params;
      return new Promise((resolve, reject) => {
        alice
          .updateConfigFile(configId, configData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updatePartialConfig(context, params) {
      const { configId, updateConfigData } = params;
      return new Promise((resolve, reject) => {
        alice
          .updatePartialConfig(configId, updateConfigData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteConfigFile(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .deleteConfigFile(configId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deletePartialConfig(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .deletePartialConfig(configId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    reloadChatServerState(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .reloadChatServerState(configId)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setPreviousSelectedPartialConfigId(context, previousPartialConfigId) {
      context.commit('setPreviousSelectedPartialConfigId', previousPartialConfigId);
    },
  },
  mutations: {
    setModelCategoryData(state, data) {
      Vue.set(state, 'categoryList', data);
    },
    setNewModelCategoryData(state, data) {
      Vue.set(state, 'newCategoryList', data);
    },
    setAllConfigFileData(state, data) {
      Vue.set(state, 'allConfigFile', data);
    },
    setConfigFileData(state, data) {
      Vue.set(state, 'configFileData', data);
    },
    setPreviousSelectedPartialConfigId(state, data) {
      Vue.set(state, 'previousSelectedPartialConfigId', data);
    },
  },
};
